import { openOverpanel } from '../stores/overpanelControl';

/* eslint-disable-next-line @typescript-eslint/no-unsafe-function-type */
const actionMap: { [key: string]: Function } = {
  availableLocation: () => openOverpanel('availableLocation'),
  drug: () => openOverpanel('drug'),
  drugForm: () => openOverpanel('drugForm'),
  drugSelection: () => openOverpanel('drugSelection'),
  drugStrength: () => openOverpanel('drugStrength'),
  drugQuantity: () => openOverpanel('drugQuantity'),
  emailCard: () => openOverpanel('emailCard'),
  location: () => openOverpanel('location'),
  search: () => openOverpanel('search'),
  textCard: () => openOverpanel('textCard'),
  textApp: () => openOverpanel('textApp'),
  imageDetails: () => openOverpanel('imageDetails'),
  compare: () => openOverpanel('compare'),
};

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const actions = (action: string, ...args: any[]): void => {
  if (actionMap[action] !== undefined) {
    actionMap[action](...args);
  }
};
